"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Circle = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const style_module_css_1 = __importDefault(require("./style.module.css"));
function Circle({ color = '#7f58af', size = 64, className, style, ...rest }) {
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)(style_module_css_1.default['lds-circle'], className), style: { background: color, width: size, height: size, ...style }, ...rest }));
}
exports.Circle = Circle;
//# sourceMappingURL=circle.js.map